import { Component } from '@angular/core';

@Component({
  selector: 'rr-check-circle-fill',
  templateUrl: './check-circle-fill.component.html',
  styleUrls: ['./check-circle-fill.component.scss'],
})
export class CheckCircleFillComponent {
  constructor() {}
}
